import { render } from "./cluster.svg?vue&type=template&id=462a07ca?inline"
const script = {}
script.render = render

export default script